"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadPolicyType = void 0;
var UploadPolicyType;
(function (UploadPolicyType) {
    UploadPolicyType["InstitutionLogo"] = "InstitutionLogo";
    UploadPolicyType["ParticipantCsvImport"] = "ParticipantCsvImport";
    UploadPolicyType["EventCeremonyOrStudentClipAsset"] = "EventCeremonyOrStudentClipAsset";
    UploadPolicyType["ParticipantBulkAudioImport"] = "ParticipantBulkAudioImport";
    UploadPolicyType["Media"] = "Media";
    UploadPolicyType["InPersonMedia"] = "InPersonMedia";
})(UploadPolicyType = exports.UploadPolicyType || (exports.UploadPolicyType = {}));
//# sourceMappingURL=upload-policy-type.js.map